class Consts {
	constructor() {
		this.MSG_CONFIRM_REGISTER = 'データを登録します。よろしいですか？';
		this.MSG_CONFIRM_DELETE = '選択したデータを削除します。よろしいですか？';
	}
}

export default Consts
